// Press/Media coverage data - Cluster SIE news from various sources
export const siePressData = [
  {
    id: 1,
    title: 'คลัสเตอร์ SIE เครือข่ายธุรกิจชุมชนร่วมภาคใต้ ชูอาหารและผลิตภัณฑ์ฮาลาล',
    url: 'https://siamrath.co.th/regional/news/123677',
    source: 'สยามรัฐ',
    type: 'news',
  },
  {
    id: 2,
    title: 'คลัสเตอร์ SIE ขับเคลื่อนเศรษฐกิจฐานราก',
    url: 'https://mgronline.com/entertainment/detail/9680000077902',
    source: 'ผู้จัดการออนไลน์',
    type: 'news',
  },
  {
    id: 3,
    title: 'Cluster SIE ข่าวจาก LINE TODAY',
    url: 'https://today.line.me/th/v3/article/MLYKDqa',
    source: 'LINE TODAY',
    type: 'news',
  },
  {
    id: 4,
    title: 'คลัสเตอร์ SIE เครือข่ายธุรกิจชุมชน',
    url: 'https://www.khaosod.co.th/monitor-news/news_9895296',
    source: 'ข่าวสด',
    type: 'news',
  },
  {
    id: 5,
    title: 'โครงการ Cluster SIE พัฒนาเศรษฐกิจฐานราก',
    url: 'https://www.thaipbs.or.th/news/content/357755',
    source: 'Thai PBS',
    type: 'news',
  },
  {
    id: 6,
    title: 'Cluster SIE เครือข่ายธุรกิจชุมชน',
    url: 'https://thainews.prd.go.th/thainews/news/view/1752178/?bid=1',
    source: 'กรมประชาสัมพันธ์',
    type: 'gov',
  },
  {
    id: 7,
    title: 'คลัสเตอร์ SIE ข่าวจาก TopNews',
    url: 'https://www.topnews.co.th/news/1363385',
    source: 'TopNews',
    type: 'news',
  },
  {
    id: 8,
    title: 'คลัสเตอร์ SIE เครือข่ายธุรกิจชุมชนร่วมภาคใต้ ชูอาหารและผลิตภัณฑ์ฮาลาล รองรับตลาดโลกและภัยพิบัติ',
    url: 'https://www.facebook.com/gossippooo/posts/%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%AA%E0%B9%80%E0%B8%95%E0%B8%AD%E0%B8%A3%E0%B9%8C-sie-%E0%B9%80%E0%B8%84%E0%B8%A3%E0%B8%B7%E0%B8%AD%E0%B8%82%E0%B9%88%E0%B8%B2%E0%B8%A2%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B9%83%E0%B8%95%E0%B9%89-%E0%B8%8A%E0%B8%B9%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9C%E0%B8%A5%E0%B8%B4%E0%B8%95%E0%B8%A0%E0%B8%B1%E0%B8%93%E0%B8%91%E0%B9%8C%E0%B8%AE%E0%B8%B2%E0%B8%A5%E0%B8%B2%E0%B8%A5-%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%95%E0%B8%A5%E0%B8%B2%E0%B8%94/1206548461514703/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 9,
    title: 'Cluster SIE บน Facebook (1)',
    url: 'https://www.facebook.com/share/p/1HStNHwmMb/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 10,
    title: '"คลัสเตอร์ SIE" เครือข่ายธุรกิจชุมชนร่วมภาคใต้ ชูอาหารและผลิตภัณฑ์ฮาลาล รองรับตลาดโลกและภัยพิบัติ',
    url: 'https://mthai.com/news/pr/393407.html',
    source: 'MThai',
    type: 'news',
  },
  {
    id: 11,
    title: 'Cluster SIE บน Facebook (2)',
    url: 'https://www.facebook.com/share/p/1B13TYHX9W/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 12,
    title: 'Cluster SIE วิดีโอบน Facebook',
    url: 'https://www.facebook.com/share/v/17Nq4BfKRq/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 13,
    title: 'Cluster SIE บน Facebook (3)',
    url: 'https://www.facebook.com/share/p/1DGXkvPXzD/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 14,
    title: 'Cluster SIE บน Facebook (4)',
    url: 'https://www.facebook.com/share/p/1765sbqp2W/',
    source: 'Facebook',
    type: 'social',
  },
  {
    id: 15,
    title: 'โครงการสร้างเครือข่ายธุรกิจชุมชนร่วม (Cluster)',
    url: 'https://pmua.or.th/26163/',
    source: 'บพท.',
    type: 'gov',
  },
  {
    id: 16,
    title: 'บพท. สนับสนุนโครงการ Cluster SIE',
    url: 'https://pmua.or.th/28527/',
    source: 'บพท.',
    type: 'gov',
  },
  {
    id: 17,
    title: 'คลัสเตอร์ SIE ข่าวจากแนวหน้า',
    url: 'https://www.naewna.com/local/941428',
    source: 'แนวหน้า',
    type: 'news',
  },
  {
    id: 18,
    title: 'บพท. ยกระดับเศรษฐกิจฐานรากด้วย "กลไกกลาง" SIE Cluster ดันธุรกิจชุมชนสู่ตลาดใหญ่–ตลาดโลก สร้างรายได้กว่า 700 ล้านบาท',
    url: 'https://www.ktsonline.today/%E0%B8%9A%E0%B8%9E%E0%B8%97-%E0%B8%A2%E0%B8%81%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%90%E0%B8%B2%E0%B8%99%E0%B8%A3%E0%B8%B2%E0%B8%81%E0%B8%94%E0%B9%89%E0%B8%A7%E0%B8%A2-%E2%80%9C%E0%B8%81%E0%B8%A5%E0%B9%84%E0%B8%81%E0%B8%81%E0%B8%A5%E0%B8%B2%E0%B8%87%E2%80%9D-sie-cluster-%E0%B8%94%E0%B8%B1%E0%B8%99%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99%E0%B8%AA%E0%B8%B9%E0%B9%88%E0%B8%95%E0%B8%A5%E0%B8%B2%E0%B8%94%E0%B9%83%E0%B8%AB%E0%B8%8D%E0%B9%88%E2%80%93%E0%B8%95%E0%B8%A5%E0%B8%B2%E0%B8%94%E0%B9%82%E0%B8%A5%E0%B8%81-%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B9%84%E0%B8%94%E0%B9%89%E0%B8%81%E0%B8%A7%E0%B9%88%E0%B8%B2-700-%E0%B8%A5%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%9A%E0%B8%B2%E0%B8%97',
    source: 'KTS Online',
    type: 'news',
  },
  {
    id: 19,
    title: 'มทร.อีสาน ข่าว Cluster SIE',
    url: 'https://rmuti.ac.th/one/prnews110867-2/',
    source: 'มทร.อีสาน',
    type: 'edu',
  },
  {
    id: 20,
    title: 'Cluster SIE ข่าวจากสยิงม้วลชน',
    url: 'https://www.seingmualchon.com/145519/',
    source: 'สยิงม้วลชน',
    type: 'news',
  },
  {
    id: 21,
    title: 'คลัสเตอร์ SIE เสริมแกร่งธุรกิจชุมชน',
    url: 'https://bangkok-today.com/%e0%b8%84%e0%b8%a5%e0%b8%b1%e0%b8%aa%e0%b9%80%e0%b8%95%e0%b8%ad%e0%b8%a3%e0%b9%8c-sie-%e0%b9%80%e0%b8%aa%e0%b8%a3%e0%b8%b4%e0%b8%a1%e0%b9%81%e0%b8%81%e0%b8%a3%e0%b9%88%e0%b8%87%e0%b8%98%e0%b8%b8/',
    source: 'Bangkok Today',
    type: 'news',
  },
  {
    id: 22,
    title: 'โครงการ SIE ข่าวจาก News24 Thailand',
    url: 'https://www.news24-thailand.com/2026/01/sie.html',
    source: 'News24',
    type: 'news',
  },
  {
    id: 23,
    title: 'Cluster SIE ข่าวจากประชาสัมพันธ์จังหวัดร้อยเอ็ด',
    url: 'https://roiet.prd.go.th/th/content/category/detail/id/877/iid/472010',
    source: 'ปชส.ร้อยเอ็ด',
    type: 'gov',
  },
  {
    id: 24,
    title: 'SIE REAL IMPACT - วิดีโอ YouTube',
    url: 'https://youtu.be/mJrinHWyO7U?si=ZZjBFZHyLRJSG1a6',
    source: 'YouTube',
    type: 'video',
  },
  {
    id: 25,
    title: 'กรมหม่อนไหมหารือแนวทางพัฒนาเครือข่ายธุรกิจชุมชน เสริมสร้างเศรษฐกิจฐานรากอย่างยั่งยืน',
    url: 'https://www.facebook.com/poranee11',
    source: 'Facebook',
    type: 'social',
  },
]

// Source type config for styling
export const sieSourceTypeConfig = {
  'news': { label: 'สื่อข่าว', color: 'blue', icon: '📰' },
  'social': { label: 'โซเชียล', color: 'indigo', icon: '💬' },
  'gov': { label: 'หน่วยงานรัฐ', color: 'emerald', icon: '🏛️' },
  'edu': { label: 'สถาบันการศึกษา', color: 'purple', icon: '🎓' },
  'video': { label: 'วิดีโอ', color: 'red', icon: '🎬' },
}
